import React from "react";

export const UploadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ?? 48}
    height={props.height ?? 48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 32.008V34C8 35.5913 8.63214 37.1174 9.75736 38.2426C10.8826 39.3679 12.4087 40 14 40H34C35.5913 40 37.1174 39.3679 38.2426 38.2426C39.3679 37.1174 40 35.5913 40 34V32M24 31V9M24 9L31 16M24 9L17 16" stroke={props.stroke ?? "currentColor"} strokeWidth={props.strokeWidth ?? 3} strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default UploadIcon;
